import { IStepProps } from './types';

export const Step = ({ steps, initialStep }: IStepProps) => {
  return <div id="step-wrapper">{steps[initialStep]}</div>;
};
